export default __webpack_public_path__ + "static/media/zanskar3.4e1402e5.jpg";